import React from 'react';
import { motion } from 'framer-motion';
import useInView from '../../hooks/useInView';
import styles from './Values.module.css';

/**
 * Values block — modeled on Social Dallas's HOUSE OF PRAYER / PRESENCE / PEOPLE
 * slider. Three big phrases stacked vertically with asymmetric horizontal
 * offsets, each row sliding in from an alternating direction with a stagger.
 *
 * Roboto Black, uppercase, on the black section ground.
 */
const PILLARS = [
  {
    text: 'Unashamed.',
    verse: 'Romans 1:16',
    align: 'left',   // horizontal anchor inside the row
    from: 'left',    // animation slide-in direction
  },
  {
    text: 'Undivided.',
    verse: 'Acts 2:42–47',
    align: 'right',
    from: 'right',
  },
  {
    text: (
      <>
        In Spirit &{' '}
        <span className={styles.phraseHighlight}>In Truth.</span>
      </>
    ),
    verse: 'John 4:23–24',
    align: 'center',
    from: 'left',
  },
];

export default function Values() {
  return (
    <section id="values" className={`${styles.section} dark-block`}>
      <div className={styles.shell}>
        {PILLARS.map((p, i) => (
          <Row key={i} {...p} index={i} />
        ))}
      </div>
    </section>
  );
}

function Row({ text, verse, align, from, index }) {
  const [ref, inView] = useInView({ threshold: 0.22 });
  const fromX = from === 'left' ? '-18%' : '18%';

  return (
    <div
      ref={ref}
      className={`${styles.row} ${styles[`row_${align}`]}`}
    >
      <motion.h2
        className={styles.phrase}
        initial={{ x: fromX, opacity: 0 }}
        animate={inView ? { x: 0, opacity: 1 } : {}}
        transition={{
          duration: 1.1,
          delay: 0.05 + index * 0.18,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {text}
      </motion.h2>
      <motion.span
        className={styles.verse}
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{
          duration: 0.8,
          delay: 0.6 + index * 0.18,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {verse}
      </motion.span>
    </div>
  );
}
